<template>
  <div class="poll">
    <div
      v-for="(option, index) in options"
      v-bind:key="index"
    >
      <whats-app-option
        v-bind:initialPercentage="calculatePercentage(option.votes.length)"
        v-bind:initial-text="option.text"
      />
    </div>
  </div>
</template>

<script>
import WhatsAppOption from '@/components/WhatsAppPollOption.vue';

export default {
  /**
   * Опрос.
   */
  name: 'WhatsAppPoll',
  components: { WhatsAppOption },
  data() {
    return {
      /**
       * @description Количество всех голосующих
       * @type Number
       */
      countAllVoters: this.options.reduce((acc, item) => acc + item.votes.length, 0),
    };
  },
  props: {
    /**
     * @description Опции опроса.
     * @type Array<Object>>
     */
    options: { type: Array, required: true },
  },
  methods: {
    calculatePercentage(optionVoters) {
      if (optionVoters === 0) return 0;
      return Math.ceil((optionVoters / this.countAllVoters) * 100);
    },
  },
};

</script>

<style scoped lang="scss">
.poll {
  min-width: 250px;
}

</style>
